export default __webpack_public_path__ + "static/media/EM0050.34I-19681_-17075_0.1668f993.jpg";